<template>
  <aside class="ui-box ui-custom-scrollbar container">
    <EbMenu :default-active="activeMenu" :default-openeds="defaultOpeneds">
      <!-- // eslint-disable-next-line max-len -->
      <div
        v-for="item of filterRoutes"
        v-show="
          !item.hidden && !(item.auth && !item.auth.includes(profile.role))
        "
        :key="item.index"
      >
        <template v-if="item.children">
          <EbSubmenu :index="item.index">
            <template slot="icon">
              <i :class="['navbar-iconfont', item.iconName]" />
            </template>
            <template slot="title">
              <span class="title">{{ item.title }}</span>
            </template>

            <EbMenuItem
              v-for="child of item.children"
              v-show="!child.hidden"
              :key="child.index"
              :index="child.index"
              :route="child.route"
            >
              <span class="title">{{ child.title }}</span>

              <!-- 权限管理页(解绑未读数量通知) -->
              <span
                v-if="isAdminAndMCN && item.unreadNum && item.unreadNum > 0"
                class="navbar-unread-icon-number"
              >
                {{ item.unreadNum }}
              </span>
            </EbMenuItem>
          </EbSubmenu>
        </template>
      </div>
    </EbMenu>
  </aside>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NavBar',
  data() {
    return {
      routes: [
        {
          index: '5',
          title: '数据管理',
          iconName: 'icon-data',
          auth: [100, 200, 300],
          children: [
            {
              index: '5-2',
              route: '/statistic/summary',
              title: '数据概览',
            },
            {
              index: '5-3',
              route: '/statistic/order',
              title: '订单明细',
            },
          ],
        },
        {
          index: '3',
          route: '/manage',
          title: '我的橱窗',
          iconName: 'icon-all',
          auth: [100, 200, 300, 201],
          children: [
            {
              index: '3-1',
              route: '/manage/kg',
              title: '全民K歌',
              mask: 'kg',
            },
            {
              index: '3-2',
              route: '/manage/ws',
              title: '腾讯微视',
              mask: 'ws',
            },
            {
              index: '3-3',
              route: '/manage/om',
              title: '企鹅号',
              mask: 'om',
            },
            {
              index: '3-4',
              route: '/manage/qq',
              title: 'QQ',
              mask: 'qq',
            },
            {
              index: '3-5',
              route: '/manage/txvideo',
              title: '腾讯视频',
              mask: 'txvideo',
            },
            {
              index: '3-6',
              route: '/manage/kdlive',
              title: '看点直播',
              mask: 'kdlive',
            },
            {
              index: '3-7',
              route: '/manage/kd_app',
              title: '看点App',
              mask: 'kd_app',
            },
            {
              index: '3-8',
              route: '/manage/qq_xsj',
              title: 'QQ小世界',
              mask: 'qq_xsj',
            },
          ],
        },
        {
          index: '10',
          route: '/selectedGoods/unknown/0',
          routeName: 'selectedGoods',
          title: '选品管理',
          iconName: 'icon-home',
          auth: [100, 200, 300, 201],
          children: [
            {
              index: '10-1',
              route: '/selectedGoods/unknown/0',
              routeName: 'selectedGoods',
              title: '选品中心',
            },
          ],
        },
        //  关闭营销入口
        // {
        //   index: '4',
        //   route: '/marketing',
        //   title: '营销模块',
        //   iconName: 'icon-coupons',
        //   auth: [100, 200, 300],
        //   children: [
        //     {
        //       index: '4-1',
        //       route: '/marketing/live-room',
        //       title: '优惠券',
        //       iconName: 'collect',
        //     },
        //   ],
        // },
        {
          index: '8',
          route: '/authManage',
          title: '权限管理',
          auth: [100, 200, 300, 201],
          iconName: 'icon-solution',
          children: [
            {
              index: '8-1',
              route: '/authManage',
              title: '权限中心',
            },
          ],
        },
        {
          index: '9',
          route: '/settlement',
          title: '结算管理',
          iconName: 'icon-consumption',
          auth: [100, 200, 300],
          children: [
            {
              index: '9-1',
              route: '/settlement',
              title: '结算中心',
            },
          ],
        },
        {
          index: '2',
          route: '/userCenter',
          title: '资料管理',
          iconName: 'icon-account',
          auth: [100, 200, 300, 201],
          children: [
            {
              index: '2-1',
              route: '/userCenter',
              title: '我的资料',
            },
          ],
        },
      ],
    };
  },
  computed: {
    activeMenu() {
      const routePath = this.$route.path;
      const routeName = this.$route.name;
      const { matchIndex, matchSubIndex } = this.getActiveRouteIndex(
        routePath,
        routeName
      );

      if (typeof matchSubIndex !== 'number') {
        // 未匹配子菜单时，默认无高亮菜单
        return '';
      }

      return this.routes[matchIndex].children[matchSubIndex].index;
    },
    defaultOpeneds() {
      return [this.activeMenu.slice(0, 1)];
    },
    ...mapState({
      profile: state => state.userCenter.profile,
      unreadNum: state => state.authManage.unreadNum,
    }),
    // 过滤得到已开通的媒体列表
    filterRoutes() {
      const { media_binding: mediaBindList, role } = this.profile;

      // 过滤绑定媒体名称
      const authMediaBindList = mediaBindList
        ? mediaBindList
          .filter(media => media.has_authenticated === 1)
          .map(media => media.mask)
        : [];
      const filterRoutes = this.routes.filter((route) => {
        if (route.route === '/settlement') return role === 100;
        // if (route.route === "/settlement") return role === 100;
        if (route.route === '/marketing') {
          return mediaBindList.some(item => item.mask === 'txvideo');
        }

        // 未分配用户和达人不具备权限管理tab
        if (route.route !== '/authManage') return true;
        return role !== 0 && role !== 300;
      });
      const routes = filterRoutes.map((route) => {
        if (route.route === '/authManage') {
          route.unreadNum = this.unreadNum;
        }

        if (route.route !== '/manage') {
          return route;
        }

        // 允许访问的媒体端列表
        // eslint-disable-next-line max-len
        const children = route.children.filter(child => authMediaBindList.some(name => child.mask === name));
        // 若不存在可访问的媒体端，隐藏父级route
        if (!children.length) {
          route.hidden = true;
        }

        return {
          ...route,
          children,
        };
      });

      return routes;
    },
    // 是否为机构，并且角色为管理员
    isAdminAndMCN() {
      return this.profile.identity == 1 && this.profile.role == 100;
    },
  },
  mounted() {
    // 初始化调用获取用户未处理的解绑申请，展示在navbar中
    this.$store.dispatch('authManage/setUnreadNum');
  },
  methods: {
    getActiveRouteIndex(routePath, routeName) {
      let matchIndex = null;
      let matchSubIndex = null;

      this.routes.forEach((route, index) => {
        if (route.route === routePath || route.routeName === routeName) {
          matchIndex = index;
        }

        if (route.children) {
          route.children.forEach((childRoute, subIndex) => {
            if (
              childRoute.route === routePath
              || childRoute.routeName === routeName
            ) {
              matchIndex = index;
              matchSubIndex = subIndex;
            }
          });
        }
      });

      return { matchIndex, matchSubIndex };
    },
  },
};
</script>

<style lang="less" scoped>
@import "./navbar/navbar_iconfont.css";

.container {
  height: 100%;
  overflow: auto;
  color: #1f1f1f;
  box-sizing: border-box;
  padding: 10px 0;
}
.title {
  min-width: 4em;
}
.navbar-unread-icon-number {
  margin-left: 5px;
  display: inline-flex;
  justify-content: center;
  background-color: #e34d59;
  height: 16px;
  line-height: 16px;
  border-radius: 8px;
  color: #ffffff;
  font-size: 12px;
  width: 28px;
}
.sub-menu-wrap {
  border-bottom: 1px solid #f00;
}
</style>
